export const DEFAULT_VIEWPORT_HEIGHT = 56;
export const DEFAULT_INTERVAL_MS = 4000;
export const DEFAULT_SCROLL_DURATION_MS = 400;
